import {startHeroScroll} from './heroScroll.util.js';

const {KitModule, registerModule} = window;

class SplicedLineArt extends KitModule {
    constructor($element) {
        super($element);
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');
        this.syncMotion = this.syncMotion.bind(this);
        this.motionPreference.addEventListener('change', this.syncMotion);
        this.syncMotion();
    }

    syncMotion() {
        this.stopMotion();
        if (!this.motionPreference.matches) return;

        const center = this.$element.viewBox.baseVal.width / 2;
        this.stopHeroScroll = startHeroScroll({
            target: this.$element.closest('.engineering-article__header'),
            endViewport: 0.25,
            items: [...this.$element.querySelectorAll('image')].map((element) => ({
                element,
                // Equal travel preserves each row's gaps as both sides open out.
                x: (element.x.baseVal.value + element.width.baseVal.value / 2 < center ? -1 : 1) * 144,
            })),
        });
    }

    stopMotion() {
        this.stopHeroScroll?.();
        this.stopHeroScroll = null;
    }

    unmount() {
        this.motionPreference.removeEventListener('change', this.syncMotion);
        this.stopMotion();
    }
}

registerModule('SplicedLineArt', SplicedLineArt);
